import React from "react";

export function Button({
  variant = "primary",
  size = "md",
  block = false,
  loading = false,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  type = "button",
  className = "",
  children,
  ...rest
}) {
  const cls = ["ca-btn", `ca-btn--${variant}`, size !== "md" ? `ca-btn--${size}` : "", block ? "ca-btn--block" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={cls} disabled={disabled || loading} {...rest}>
      {loading ? <span className="ca-btn__spinner" /> : iconLeft}
      {children}
      {iconRight}
    </button>
  );
}
